function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  viewBox: "0 0 26 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  className: (styles["loader-logo__item"] || "loader-logo__item") + " " + (styles["loader-logo__item--1"] || "loader-logo__item--1"),
  d: "m8.8709 0c-1.026 0-1.8709 0.896-1.8709 2.0053 0 1.0987 0.84493 1.9947 1.8709 1.9947h8.2682c1.0159 0 1.8609-0.896 1.8609-2.0053 0-1.0987-0.84493-1.9947-1.8609-1.9947h-8.2682z"
}), /*#__PURE__*/React.createElement("path", {
  className: (styles["loader-logo__item"] || "loader-logo__item") + " " + (styles["loader-logo__item--2"] || "loader-logo__item--2"),
  d: "m20.189 9.9894c1.0002 0 1.8111-0.89305 1.8111-1.9947 0-1.1016-0.81086-1.9947-1.8111-1.9947h-14.392c-0.9949 0-1.7966 0.89362-1.7966 2s0.80172 2 1.7966 2h14.392v-0.010638z"
}), /*#__PURE__*/React.createElement("path", {
  className: (styles["loader-logo__item"] || "loader-logo__item") + " " + (styles["loader-logo__item--3"] || "loader-logo__item--3"),
  d: "m15.195 16c0.99512 0 1.8049-0.896 1.8049-2.0053 0-1.0987-0.80976-1.9947-1.8049-1.9947h-4.4098c-0.97561 0-1.7854 0.896-1.7854 2.0053 0 1.0987 0.80976 1.9947 1.7854 1.9947h4.4098z"
}));